import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('font-awesome-icon',_vm._g(_vm._b({staticClass:"fa-lg",staticStyle:{"color":"dodgerblue"},attrs:{"icon":_vm.icons.help}},'font-awesome-icon',attrs,false),on))]}}])},[_c('div',{staticClass:"thresholdTooltip"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }